import { render, staticRenderFns } from "./personal-info.vue?vue&type=template&id=7aedc016&scoped=true"
import script from "./personal-info.vue?vue&type=script&lang=js"
export * from "./personal-info.vue?vue&type=script&lang=js"
import style0 from "./personal-info.vue?vue&type=style&index=0&id=7aedc016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aedc016",
  null
  
)

export default component.exports